<div class="card position-relative">
  @if (isLoading || isSaving) {
    <loader [config]="{ type: 'spinner', overlay: true, size: 'md' }"></loader>
  }

  <div class="card-header d-flex align-items-center gap-2">
    <h3 class="card-title mb-0">{{ isUpdate ? 'Edit VLT' : 'Create VLT' }}</h3>
  </div>

  <div class="card-body">
    <regulator-context-box [items]="contextItems" (back)="goBack()" />

    <form [formGroup]="form" (ngSubmit)="submitForm()">
      <div class="row g-3">
        <div class="col-md-4">
          <input-field type="text" label="Code *" placeholder="VLT-RM-0001" [inputFormControl]="control('code')" />
        </div>
        <div class="col-md-4">
          <input-field type="text" label="Serial Number *" placeholder="Serial number" [inputFormControl]="control('serialNumber')" />
        </div>
        <div class="col-md-4">
          <select-field label="Status *" [options]="statusOptions" [selectFormControl]="control('status')" />
        </div>

        <div class="col-md-6">
          <input-field type="text" label="Manufacturer" placeholder="Manufacturer" [inputFormControl]="control('manufacturer')" />
        </div>
        <div class="col-md-6">
          <input-field type="text" label="Model" placeholder="Model" [inputFormControl]="control('model')" />
        </div>

        <div class="col-md-6">
          <input-field type="text" label="Venue *" placeholder="Venue" [inputFormControl]="control('venue')" />
        </div>
        <div class="col-md-6">
          <input-field type="text" label="Address" placeholder="Address" [inputFormControl]="control('address')" />
        </div>

        <div class="col-md-6">
          <input-field type="text" label="City *" placeholder="City" [inputFormControl]="control('city')" />
        </div>
        <div class="col-md-6">
          <input-field type="text" label="Country" placeholder="Country" [inputFormControl]="control('country')" />
        </div>

        <div class="col-md-4">
          <input-field type="number" label="Latitude" placeholder="e.g. 41.8925" [inputFormControl]="control('latitude')" />
          @if (control('latitude').errors?.['min'] || control('latitude').errors?.['max']) {
            <small class="text-danger">Latitude must be between -90 and 90</small>
          }
        </div>
        <div class="col-md-4">
          <input-field type="number" label="Longitude" placeholder="e.g. 12.4880" [inputFormControl]="control('longitude')" />
          @if (control('longitude').errors?.['min'] || control('longitude').errors?.['max']) {
            <small class="text-danger">Longitude must be between -180 and 180</small>
          }
        </div>
        <div class="col-md-4">
          <input-field type="datetime-local" label="Last Seen" [inputFormControl]="control('lastSeenTime')" />
        </div>
      </div>

      <div class="d-flex justify-content-center gap-3 mt-4">
        <button type="button" class="btn btn-secondary px-4 py-2" (click)="goBack()">Cancel</button>
        <button type="submit" class="btn btn-success px-4 py-2" [disabled]="isSaving">Save</button>
      </div>
    </form>
  </div>
</div>
